import React from 'react'
import {Icon} from './icon'
import {IconLook} from './icon_look'

export const Legend = ({showByType}) => {
  const content = Object.keys(IconLook).map((key, i) => {
    return <div className='ndnr-legend-entry' key={i} onClick={() => showByType(key)}>
      <Icon name={key} />
      <span className='tile-subtitle'>{key}</span>
    </div>
  })
  return <div className='ndnr-legend mt-2'>
    {content}
  </div>
}



// WEBPACK FOOTER //
// ./src/legend.js